import { ApiUrls } from '@/service/constants/urls';
import { instance } from '../Axios';
import {
    TAvailabilityDayParams,
    TAvailabilityDayBody,
    TAvailabilityDayResponse,
} from '@/domain/FullCalendar.domain';
import { replaceLightframe } from '@/service/utils/replaceLightframe';

export const getAvailabilityDay = async (
    params: TAvailabilityDayParams,
    body: TAvailabilityDayBody
): Promise<TAvailabilityDayResponse[]> =>
    instance
        .post(`${ApiUrls.availability.day.root}?partnerId=${replaceLightframe(params.partnerId)}`, {
            ...body,
        })
        .then(({ data }) => data);
